import type { ICompanySettings, IDataCompanySettings } from '@/types/Data'
import type { IPayloadCompanySetting } from '@/types/Request'
import type { IResponse } from '@/types/Utils/IBaseService'
import { Alert, Format } from '@/utils-ts'

export async function fetchSimpleList(
  getList: () => Promise<IResponse<ICompanySettings[]>>,
): Promise<IDataCompanySettings[] | null> {
  const { data, status } = await getList()
  if (!status) return null
  return data.map(item => ({ ...item, isDisabled: true, firstValue: item.name }))
}

export async function createSimpleListItem(
  create: (name: string) => Promise<IResponse<ICompanySettings>>,
  name: string,
  successMessage: string = Format('admin_global_success'),
): Promise<IDataCompanySettings | null> {
  const { data, status } = await create(name)
  if (!status) return null
  void Alert({ type: 'success', message: successMessage })
  return { ...data, isDisabled: true, firstValue: data.name }
}

export async function updateSimpleListItem(
  update: (payload: IPayloadCompanySetting) => Promise<IResponse<unknown>>,
  payload: IPayloadCompanySetting,
): Promise<boolean> {
  const { status } = await update(payload)
  if (status) {
    void Alert({ type: 'success', message: Format('admin_global_updated') })
  }
  return status
}

export async function deleteSimpleListItem(
  deleteFn: (id: string) => Promise<IResponse<unknown>>,
  id: string,
): Promise<boolean> {
  const { status } = await deleteFn(id)
  if (status) {
    void Alert({ type: 'success', message: Format('admin_global_deleted') })
  }
  return status
}
